import { render, staticRenderFns } from "./ConfigurationSystemRouterView.vue?vue&type=template&id=69fba8f6&scoped=true&"
import script from "./ConfigurationSystemRouterView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSystemRouterView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSystemRouterView.vue?vue&type=style&index=0&id=69fba8f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fba8f6",
  null
  
)

export default component.exports